import React from 'react';
import { Svg } from 'src/components/Svg/Svg';
import classnames from 'classnames';

import classes from './BasketSummary.scss';

type Props = {
    location: 'basket' | 'checkout';
    background?: boolean;
};

export const SummaryPromise: React.FC<Props> = ({ location, background }) => (
    <div
        className={classnames(classes.summaryPromise, {
            [classes.summaryPromiseBasket]: location === 'basket',
            [classes.summaryPromiseCheckout]: location === 'checkout',
        })}
    >
        <div
            className={classnames(classes.summaryPromiseBlock, {
                [classes.summaryPromiseBackground]: background,
            })}
        >
            <span className={classes.summaryPromiseTitle}>
                <Svg name="promise" />
                <b>Adding a new logo or text?</b> We'll email a mock up to approve before we begin!
            </span>
        </div>
    </div>
);
